// import { Input } from "./Input";
import searchIcon from "../../images/icons/search.png";
import logo from "../../images/icons/Logo.svg";
import insta from "../../images/icons/instagram2.svg";
import tiktok from "../../images/icons/tiktok.svg";
import phone from "../../images/icons/teephone.png";
import { Link } from "react-router-dom";

export default function Header() {
  return (
    <header>
      <div className="container">
        <div className="header">
          <Link to="/filter" className="header__search">
            <img src={searchIcon} alt="search" />
          </Link>
          <div className="header__logo">
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className="header__contacts">
            <a href="https://www.instagram.com/liberica.espresso.bar/">
              <img src={insta} alt="instagram" width={60} />
            </a>
            <a href="https://www.tiktok.com/@libericaespressobar">
              <img src={tiktok} alt="tiktok" width={29} />
            </a>
            <a href="tel: +380670777332">
              <img src={phone} alt="telefone" />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
